import { observable } from 'mobx';

export type RailwayAreaResponseArgs = {
  id: number;
  area: string;
  service_id: string;
  ticketing_qr_service: number;
  created_at: string;
  updated_at: string;
};

export type RailwayAreaArgs = {
  id: number;
  area: string;
  serviceId: string;
  ticketingQrService: number;
  createdAt: string;
  updatedAt: string;
};

export const convertRailwayAreaResponseToArgs = (response: RailwayAreaResponseArgs): RailwayAreaArgs => {
  return {
    id: response.id,
    area: response.area,
    serviceId: response.service_id,
    ticketingQrService: response.ticketing_qr_service,
    createdAt: response.created_at,
    updatedAt: response.updated_at
  };
};

export default class RailwayArea {
  @observable id: number;
  @observable area: string;
  @observable serviceId: string;
  @observable ticketingQrService: number;
  @observable createdAt: string;
  @observable updatedAt: string;

  constructor(args: RailwayAreaArgs) {
    this.id = args.id;
    this.area = args.area;
    this.serviceId = args.serviceId;
    this.ticketingQrService = args.ticketingQrService;
    this.createdAt = args.createdAt;
    this.updatedAt = args.updatedAt;
  }

  get submitParams() {
    return {
      ticketing_qr_service: this.ticketingQrService
    };
  }
}
